import React from "react";
import { Button } from "@mui/material";
import ChatIcon from "@mui/icons-material/Chat";

const FloatingChatButton = ({ onClick, visible }) => {
  return (
    <Button
      variant="contained"
      color="primary"
      onClick={onClick}
      sx={{
        position: "fixed",
        bottom: 16,
        right: 16,
        borderRadius: "50%",
        padding: "12px",
        minWidth: "unset",
        width: "56px",
        height: "56px",
        zIndex: 1000,
        backgroundColor: "#EF4F26",
        opacity: visible ? 1 : 0,
        transform: visible ? "scale(1)" : "scale(0.9)",
        transition: "opacity 0.5s ease, transform 0.5s ease",
        pointerEvents: visible ? "auto" : "none",
        "&:hover": {
          backgroundColor: "#D4411E",
        },
      }}
    >
      <ChatIcon />
    </Button>
  );
};

export default FloatingChatButton;